var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-card',{staticClass:"box-card"},[_c('div',[_c('p',{staticClass:"tip-div"},[_vm._v(" 本界面显示的体积重是按照标准系数【10000】计算的，仅供参考！财务结算时会根据上传的长宽高重新计算体积重。 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }